<template>
  <div class="dashboard-header">
    <div class="header-title">
      {{ title }}
    </div>
    <div class="header-inner">
      <div class="glossary-link">
        <Anchor
          href="https://drive.google.com/uc?export=download&id=1n3Bvkj4uXknkVgXTd5mTyrasppb8_Bt7"
          @click="downloadGlossaryAnalytics"
        >
          <template v-slot:icon>
            <GlossaryIcon />
          </template>
          MikMak Glossary
        </Anchor>
      </div>
      <BrandSelector v-show="viewHasBrandSelector" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Anchor, GlossaryIcon } from '@mikmak/components';
import BrandSelector from './BrandSelector.vue';
import eventDispatcher from '../../events/dispatch';
import { BENCHMARKS_TABS } from '../dashboard/Views/config/benchmarksCards';

export default {
  components: {
    Anchor,
    BrandSelector,
    GlossaryIcon,
  },
  computed: {
    ...mapState({
      activeBenchmarksView: state => state.benchmarks.activeBenchmarksView,
      activeView: state => state.main.activeView,
      showNewBrandSelector: state => state.main.showNewBrandSelector,
    }),
    viewHasBrandSelector() {
      return this.showNewBrandSelector && this.activeView !== 'Shopper Intelligence';
    },
    benchmarksView() {
      return this.activeView === 'Benchmarks'
        && this.activeBenchmarksView
        && BENCHMARKS_TABS[this.activeBenchmarksView];
    },
    title() {
      if (this.benchmarksView) return this.benchmarksView.name;

      return this.activeView;
    },
  },
  methods: {
    downloadGlossaryAnalytics() {
      eventDispatcher('dashboardGlossaryDownloaded', {
        dashboard_view: this.activeView,
      });
    },
  },
};
</script>

<style scoped>
.dashboard-header {
  background-color: #f7fafc;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 92px;
  padding: 0px 24px;
}

.header-title {
  color: #223448;
  display: flex;
  font-size: 24px;
  justify-content: left;
  width: 100%;
}

.header-inner {
  align-items: center;
  display: flex;
  height: 45px;
  justify-content: right;
  margin: 0 auto;
  max-width: 1314px;
  width: 100%;
}
</style>
